import './DeceasedInfo.scss';
import { connect } from 'react-redux';
import {
  setCanContinueFalse,
  setCanContinueTrue,
} from 'state/canContinue/CanContinueActions';

import Store from 'state/Store';
import React, {
  useEffect,
} from 'react';
import { getDeceasedDetails } from 'state/deceasedDetails/DeceasedDetailsSelectors';
import { getDeceasedDetailsEnabled } from 'state/deceasedDetailsEnabled/DeceasedDetailsEnabledSelectors';
import { setDeceasedDetails } from 'state/deceasedDetails/DeceasedDetailsActions';
import { setDeceasedDetailsEnabled } from 'state/deceasedDetailsEnabled/DeceasedDetailsEnabledActions';
import {
  Content,
  StateList,
  MStateList,
  MCityList,
} from 'utils/Content';
import moment from 'moment';
import {
  beaconPattern,
  isFieldRequired,
  isValidRequiredAccountNumber,
  isRequiredValidAddress,
  isRequiredValidSSN,
  isValidDOB,
} from 'utils/Validation';
import { ReactComponent as QuestionMark } from 'assets/question.svg';
import { LFEBeaconCheckbox, LFEBeaconDatePicker, LFEBeaconDropdown, LFEBeaconInputField, LFEBeaconTooltip, LFEBeaconRadioGroup, LFEBeaconRadioButton } from 'components/shared/LFEBeaconComponents';
import MaskedInput from 'components/shared/MaskedInput/MaskedInput';

const DeceasedInfo = ({ deceasedDetails, deceasedDetailsEnabled }) => {
  const { dAddress, dAddress: { dAddressMilitary, dAddressOne, dAddressTwo, dAddressCity, dAddressState, dAddressZip }, dDOB, dSSN, dAccountNum } = deceasedDetails
  const { enableAddress, enableDOB, enableSSN, enableAccountNum } = deceasedDetailsEnabled
  const handleEventChange = (id, event) => {
    if (event && event.target && id) {
      if (id.includes('enable')) {
        Store.dispatch(setDeceasedDetailsEnabled(id, !deceasedDetailsEnabled[id]))
        if (id.includes('SSN')) {
          Store.dispatch(setDeceasedDetails('dSSN', '', id.includes('Address')))
        } else if (id.includes('AccountNum')) {
          Store.dispatch(setDeceasedDetails('dAccountNum', '', id.includes('Address')))
        }
      } else if (id === 'typeOfAddress' && event.type === 'beacon-event-click') {
        Store.dispatch(setDeceasedDetails('dAddressMilitary', !dAddressMilitary, true))
      } else {
        Store.dispatch(setDeceasedDetails(id, event.target.value, id.includes('Address')))
      }
    }
  }
  useEffect(() => {
    if ((enableAddress || enableDOB || enableSSN || enableAccountNum) &&
     ((enableAddress && isRequiredValidAddress(dAddressMilitary, dAddressOne, dAddressTwo, dAddressCity, dAddressState, dAddressZip)) || !enableAddress) &&
     ((enableDOB && isFieldRequired(dDOB) && isValidDOB(dDOB)) || !enableDOB) &&
     ((enableSSN && isRequiredValidSSN(dSSN)) || !enableSSN) &&
     ((enableAccountNum && isValidRequiredAccountNumber(dAccountNum)) || !enableAccountNum)) {
      Store.dispatch(setCanContinueTrue())
    } else {
      Store.dispatch(setCanContinueFalse())
    }
  }, [dAccountNum, dAddressCity, dAddressMilitary, dAddressOne, dAddressState, dAddressTwo, dAddressZip, dDOB, dSSN, deceasedDetails, enableAccountNum, enableAddress, enableDOB, enableSSN])
  return (
    <div>
      <p className="dn-page-text-intro">{Content.DeceasedInfoPageIntro}</p>
      <div className="additional-info-fields">
        <LFEBeaconCheckbox className='checkbox-selector-dDetails'
                           id='enableAddress'
                           data-testid='enableAddress'
                           label='Residential address'
                           checked={enableAddress}
                           onBeaconChange={(event) => handleEventChange('enableAddress', event)}
                           style={enableAddress ? { marginBottom: '16px' } : null} />
                        {enableAddress && <DeceasedAddress dAddress={dAddress}
                                                           handleEventChange={handleEventChange} />}
        <LFEBeaconCheckbox className='checkbox-selector-dDetails'
                           id='enableDOB'
                           data-testid="enableDOB"
                           label='Date of birth'
                           checked={enableDOB}
                           onBeaconChange={(event) => handleEventChange('enableDOB', event)}
                           style={enableDOB ? { marginBottom: '16px' } : null} />
        {enableDOB && <DeceasedDOB dDOB={dDOB}
                                   handleEventChange={handleEventChange} />}
        <LFEBeaconCheckbox className='checkbox-selector-dDetails'
                           id='enableSSN'
                           data-testid='enableSSN'
                           label='Social Security Number'
                           checked={enableSSN}
                           onBeaconChange={(event) => handleEventChange('enableSSN', event)}
                           style={enableSSN ? { marginBottom: '16px' } : null} />
        {enableSSN && <DeceasedSSN dSSN={dSSN} />}
        <LFEBeaconCheckbox className='checkbox-selector-dDetails'
                           id='enableAccountNum'
                           data-testid='enableAccountNum'
                           label='Account number'
                           checked={enableAccountNum}
                           onBeaconChange={(event) => handleEventChange('enableAccountNum', event)}
                           style={enableAccountNum ? { marginBottom: '16px' } : null}
        />
        {enableAccountNum && <DeceasedAccountNum dAccountNum={dAccountNum} />}
      </div>
    </div>
  );
};

const DeceasedAddress = ({ dAddress, handleEventChange }) => {
  const { dAddressMilitary, dAddressOne, dAddressTwo, dAddressCity, dAddressState, dAddressZip } = dAddress
  const { addressOneRegex, addressTwoRegex, addressCityRegex, numberOnlyRegex } = beaconPattern
  const radioOnChange = (id, event) => {
    if (event && event.target && id) {
      if (id === 'typeOfAddress') {
        Store.dispatch(setDeceasedDetails('dAddressMilitary', !dAddressMilitary, true));
      }
      handleEventChange(id, event);
    }
  }

  return (
    <div className='deceased-address-info'>
      <span data-testid='address-type-title'
            className='address-type-title'>
        Address type&nbsp;
        <span>
          <LFEBeaconTooltip orientation='vertical'
                            trigger='hover'
                            content='For situations with a non-US address, please contact us at 1-800-225-5132.'>
            <QuestionMark />
          </LFEBeaconTooltip>
        </span>
      </span>
      <LFEBeaconRadioGroup className='deceased-address-radio-object'
                           id='typeOfAddress'>
        <LFEBeaconRadioButton className='address-radio'
                              name='us-address-radio'
                              id='typeOfAddressUS'
                              data-testid='typeOfAddressUS'
                              checked={!dAddressMilitary && dAddressMilitary !== null}
                              onBeaconChange={(event) => radioOnChange('typeOfAddress', event)}
                              label='US'>
        </LFEBeaconRadioButton>
        <LFEBeaconRadioButton data-testid='typeOfAddressMil'
                              className='address-radio'
                              checked={dAddressMilitary}
                              name='military-address-radio'
                              id='typeOfAddressMil'
                              onBeaconChange={(event) => radioOnChange('typeOfAddress', event)}
                              label='Military'>
        </LFEBeaconRadioButton>
      </LFEBeaconRadioGroup>

      <div className='addresses'>
        <LFEBeaconInputField id='dAddressOne'
                             data-testid='dAddressOne'
                             className='dn-input-field dAddressOne blocked_data'
                             value={dAddressOne}
                             label='Address 1'
                             type='text'
                             pattern={addressOneRegex}
                             required={true}
                             maxlength='35'
                             min='2'
                             onBeaconInput={(event) => handleEventChange('dAddressOne', event)}
                             errorsMap={{
            required: 'Required',
            noMatchPattern: 'Invalid address'
          }} />
        <LFEBeaconInputField id='dAddressTwo'
                             data-testid='dAddressTwo'
                             className='dn-input-field dAddressTwo blocked_data'
                             value={dAddressTwo}
                             label='Address 2 (optional)'
                             type='text'
                             pattern={addressTwoRegex}
                             required={false}
                             maxlength='35'
                             min='2'
                             onBeaconInput={(event) => handleEventChange('dAddressTwo', event)}
                             errorsMap={{ noMatchPattern: 'Invalid address' }} />
      </div>
      <div className='addresses-city-state'>
        {!dAddressMilitary &&
          <LFEBeaconInputField id='dAddressCity'
                               data-testid='dAddressUsCity'
                               className='dn-input-field dAddressCity blocked_data'
                               value={dAddressCity}
                               label='City'
                               type='text'
                               pattern={addressCityRegex}
                               required={true}
                               maxlength='35'
                               min='2'
                               onBeaconInput={(event) => handleEventChange('dAddressCity', event)}
                               errorsMap={{
              required: 'Required',
              noMatchPattern: 'Invalid address'
            }} />
        }
        {dAddressMilitary &&
          <LFEBeaconDropdown id='dAddressCity'
                             data-testid='dAddressMilCity'
                             className='dn-input-field dAddressCity blocked_data'
                             required={true}
                             value={dAddressCity}
                             label='City'
                             onBeaconChange={(event) => handleEventChange('dAddressCity', event)}
                             errorsMap={{ required: 'Required' }}>
            <option value={''} />
            {MCityList.map((City) => {
              return <option value={City}
                             key={`${City}-dAddressCity`}>{City}</option>
            })}
          </LFEBeaconDropdown>}
        {!dAddressMilitary &&
          <LFEBeaconDropdown id='dAddressState'
                             data-testid='dAddressUsState'
                             className='dn-input-field dAddressState blocked_data'
                             required={true}
                             label='State'
                             value={dAddressState}
                             onBeaconChange={(event) => handleEventChange('dAddressState', event)}
                             errorsMap={{ required: 'Required' }}>

            <option value={''} />
            {StateList.map((State) => {
              return <option value={State}
                             key={`${State}-dAddressState`}>{State}</option>
            })}
          </LFEBeaconDropdown>}
        {dAddressMilitary &&
          <LFEBeaconDropdown id='dAddressState'
                             data-testid='dAddressMilState'
                             className='dn-input-field dAddressState blocked_data'
                             required={true}
                             label='State'
                             value={dAddressState}
                             onBeaconChange={(event) => handleEventChange('dAddressState', event)}
                             errorsMap={{ required: 'Required' }}>
            <option value={''} />
            {MStateList.map((State) => {
              return <option value={State}
                             key={`${State}-dAddressState`}>{State}</option>
            })}
          </LFEBeaconDropdown>
        }
      </div>
      <div className='addresses'>
        <LFEBeaconInputField id='dAddressZip'
                             data-testid='dAddressZip'
                             className='dn-input-field dAddressZip blocked_data'
                             value={dAddressZip}
                             label='Zip code'
                             type='text'
                             pattern={numberOnlyRegex}
                             required={true}
                             maxlength='5'
                             min='5'
                             onBeaconInput={(event) => handleEventChange('dAddressZip', event)}
                             errorsMap={{
            required: 'Required',
            noMatchPattern: 'Invalid zip code'
          }} />
      </div>
    </div>
  )
}

const DeceasedDOB = ({ dDOB, handleEventChange }) => {
  return (
    <div className='deceased-DOB-info'>
      <LFEBeaconDatePicker className='dDOB-picker-dDetails blocked_data'
                           id='dDOB'
                           label='Date of birth'
                           value={dDOB}
                           required={true}
                           onBeaconInput={(event) => handleEventChange('dDOB', event)}
                           max={moment().format('YYYY-MM-DD')}
                           errorsMap={{ required: 'Required' }} />
    </div>
  )
}
const DeceasedSSN = ({ dSSN }) => {

  const handleSSNChange = value => {
    Store.dispatch(setDeceasedDetails('dSSN', value, false));
  };

  return (
    <div className='deceased-SSN-info blocked_data'>
      <MaskedInput id='dSSN'
                   type='ssn'
                   label='Social Security Number:'
                   value={dSSN}
                   maxlength={9}
                   minlength={9}
                   validation={isRequiredValidSSN}
                   required={true}
                   onChange={(e) => handleSSNChange(e)} />
    </div>
  )
}
const DeceasedAccountNum = ({ dAccountNum }) => {
  const handleAccountNumChange = value => {
    Store.dispatch(setDeceasedDetails('dAccountNum', value, false));
  };

  return (
    <div className='deceased-accountNum-info blocked_data'>
      <MaskedInput id='dAccountNum'
                   type='accountNum'
                   label='Account number (one account maximum):'
                   value={dAccountNum}
                   maxlength={30}
                   minlength={2}
                   required={true}
                   validation={isValidRequiredAccountNumber}
                   onChange={(e) => handleAccountNumChange(e)} />
    </div>
  )
}

const mapStateToProps = state => ({
  deceasedDetailsEnabled: getDeceasedDetailsEnabled(state),
  deceasedDetails: getDeceasedDetails(state),
});
export default connect(mapStateToProps)(DeceasedInfo);
